import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import {
  ActivityWithCategoryAndLocationsAndReportedDetails,
  Shift,
  WithPreparedAttributes,
} from '@wilson/interfaces';
import { WilsonState } from '@wilson/non-domain-specific/decorators/wilson-state';
import { NzModalService } from 'ng-zorro-antd/modal';
import { firstValueFrom, Observable } from 'rxjs';

export type SelectedShift = Shift &
  WithPreparedAttributes & { id: string } & {
    activities: ActivityWithCategoryAndLocationsAndReportedDetails[];
  };

@Injectable({ providedIn: 'root' })
export class ShiftDrawerCloseHelperService {
  private readonly translate = inject(TranslateService);
  private readonly nzModalService = inject(NzModalService);

  @WilsonState<boolean>(true)
  public isFormPristine!: boolean;
  public isFormPristine$!: Observable<boolean>;

  public async checkPristineAndCloseDrawer({
    onOkCallback,
  }: {
    onOkCallback: () => void;
  }): Promise<boolean> {
    const clearSelection = () => {
      onOkCallback();
    };
    if (this.isFormPristine) {
      clearSelection();
      return true;
    } else {
      const modalRef = this.nzModalService.confirm<boolean>({
        nzTitle: this.translate.instant(
          'page.shift_timeline.shift_drawer.close_modal.title',
        ),
        nzContent: this.translate.instant(
          'page.shift_timeline.shift_drawer.close_modal.description',
        ),
        nzOkText: this.translate.instant(
          'page.shift_timeline.shift_drawer.close_modal.confirm',
        ),
        nzCancelText: this.translate.instant('general.cancel'),
        nzOnOk: () => {
          clearSelection();
          return true;
        },
      });

      return firstValueFrom(modalRef.afterClose);
    }
  }
}
